export const energyOrderSupplierSuccess = 'MOVE.ENERGY_ORDER.VIA_API.SUCCESS';
